import React from "react";
import './ResultPage.css';
import $ from 'jquery';
import { ResultPageState } from "./ResultPageState";
import Media from "react-media";
import ResultKoIcon from "../../resources/wrappers/ResultKo";
import ResultOkIcon from "../../resources/wrappers/ResultOk";
import { Button } from "@material-ui/core";
import { Route } from "react-router-dom";
import { ResultPageHandler } from "./ResultPageHandler";
import { GoogleTagManagerService } from "../../services/analitycs/GoogleTagManagerService";
import { StringUtils } from "../../utils/StringUtils";
import { AppUtils } from "../../utils/AppUtils";

export class ResultPage extends React.Component<any, ResultPageState> {
    desktopFooter: any | undefined = undefined;

    constructor(props: any) {
        super(props);

        this.state = {
            isSuccess: false,
            title: undefined,
            errorTitle: undefined,
            message: undefined,
            errorMessage: undefined,
            button: "",
            data: undefined,
            isCatalog: false,
            productName: undefined,
            showComplete: false
        }
    }

    componentDidMount() {
        if (!AppUtils.isPhoneOrTablet()) {
            console.log("[ResultPage] ResultPage mounting...");
            if (document.getElementById('desktop-footer-body') !== null) {
                this.desktopFooter = $("#desktop-footer-body").remove();
            }
        }

        let gtmData;

        if (this.props.location.state !== undefined) {
            this.setState({ isSuccess: this.props.location.state.isSuccess !== undefined ? this.props.location.state.isSuccess : false });
            this.setState({ title: this.props.location.state.title !== undefined ? this.props.location.state.title : undefined });
            this.setState({ errorTitle: this.props.location.state.errorTitle !== undefined ? this.props.location.state.errorTitle : undefined });
            this.setState({ message: this.props.location.state.message !== undefined ? this.props.location.state.message : undefined });
            this.setState({ errorMessage: this.props.location.state.errorMessage !== undefined ? this.props.location.state.errorMessage : undefined });
            this.setState({ button: this.props.location.state.button !== undefined ? this.props.location.state.button : "" });
            this.setState({ isCatalog: this.props.location.state.isCatalog !== undefined ? this.props.location.state.isCatalog : false });
            if (this.props.location.state.data !== undefined) {
                this.setState({ data: this.props.location.state.data });
                let from = this.props.location.state.data.from;
                if (from !== undefined && from === "ChangePassword") {
                    this.setState({
                        errorMessage: ["Ti ricordiamo, inoltre, che la nuova password non può corrispondere a quella attuale e alle cinque precedentemente utilizzate.",
                            <br />, <br />, "Devi inserirne una nuova."]
                    })
                } else if (from !== undefined && from === "ChooseTerminal") {
                    let email = this.props.location.state.data.email;
                    this.setState({
                        message: ["Abbiamo inviato un’email a ", <b>{email}</b>, " con le credenziali per accedere all’App Nexi POS."]
                    })
                } else if (from !== undefined && from === "MobileSearchOverlay") {
                    let email = this.props.location.state.data.email;
                    this.setState({
                        message: ["Abbiamo inviato un’email a ", <b>{email}</b>, " con le credenziali per accedere all’App Nexi POS."]
                    })
                }
                this.setState({ productName: this.props.location.state.data.productName });
                this.setState({ showComplete: this.props.location.state.data.showComplete });
            }

            gtmData = this.buildGTMData();
        } else {
            this.setState({ isSuccess: false });
            this.setState({ title: undefined });
            this.setState({ errorTitle: undefined });
            this.setState({ message: undefined });
            this.setState({ errorMessage: undefined });
            this.setState({ button: "" });

            gtmData = {};
        }

        // Send gtm event
        if (!this.props.location.state.isCatalog) {
            GoogleTagManagerService.getInstance().pushPageEvent(this.props.history.location.pathname, 'Esito', { ...gtmData });
        } else {
            let isMassive = this.props.location.state.isMassiveImport;
            if (isMassive) {
                GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: importazione prodotti: esito positivo');
            } else {
                GoogleTagManagerService.getInstance().pushInteractionEvent('popupImpression', 'Popup', 'impression', 'catalogo prodotti: creazione prodotto: esito positivo');
            }
        }
    }

    componentWillUnmount() {
        if (!AppUtils.isPhoneOrTablet()) {
            console.log("[ResultPage] ResultPage unmounting...");
            if (this.desktopFooter !== undefined) {
                $("#app").append(this.desktopFooter);
            }
        }
    }

    buildGTMData(): object {
        let success = this.props.location.state.isSuccess !== undefined ? (this.props.location.state.isSuccess ? true : false) : false;

        let result = this.props.location.state.isSuccess !== undefined ? (this.props.location.state.isSuccess ? 'ok' : 'ko') : 'ko';
        let title = '';
        let message = '';
        let from = this.props.location.state.data.from;

        if (success) {
            if (StringUtils.checkIfEmailInString(this.props.location.state.title)) {
                try {
                    let stringArray = this.props.location.state.title.split(' ');
                    title = stringArray.splice(0, stringArray.length - 2).join(' ');
                } catch (error) {
                    title = '';
                }
            } else {
                title = this.props.location.state.title;
            }
            message = this.props.location.state.message;
            if ((from !== undefined && from === "ChooseTerminal") || (from !== undefined && from === "MobileSearchOverlay")) {
                message = 'Abbiamo inviato una mail con le credenziali per accedere all’App Nexi POS.';
            }
        } else {
            title = 'Abbiamo riscontrato un problema tecnico.';
            if (this.props.location.state.errorTitle !== undefined) {
                title = this.props.location.state.errorTitle;
            }
            message = 'Riprova più tardi. Grazie per la pazienza';
            if (from !== undefined && from === "ChangePassword") {
                message = 'Ti ricordiamo, inoltre, che la nuova password non può corrispondere a quella attuale e alle cinque precedentemente utilizzate. Devi inserirne una nuova.';
            }
        }

        // building data...
        let data = {
            result: result,
            title: title,
            message: message
        };
        return data;
    }

    getMarginForButton(): number {
        if (!AppUtils.isPhoneOrTablet()) {
            let main = document.getElementById('result-dialog-main-container');
            let element = document.getElementById('result-view-catalog-result');
            let button = document.getElementById('result-dialog-submit-button');
            let space = main?.offsetHeight! - element?.offsetHeight! + button?.offsetHeight! - 30;
            return space;
        } else {
            return 0;
        }
    }

    render() {
        return <div id={"result-dialog-main-container"}>
            <div className={"result-dialog-main-content"}>
                {
                    this.props.location.state.isCatalog ? <div id={"result-view-catalog-result"}>
                        <Media query="(max-width: 1064px)">
                            {matches => {
                                if (matches) {
                                    // Mobile
                                    return <div id={this.state.isSuccess ? "result-dialog-icon" : "result-dialog-icon-error"}>
                                        {
                                            this.state.isSuccess ?
                                                <ResultOkIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} /> : <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />
                                        }
                                    </div>
                                } else {
                                    // Desktop
                                    return <div id={"result-dialog-icon"}>
                                        {
                                            this.state.isSuccess ?
                                                <ResultOkIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} /> : <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />
                                        }
                                    </div>
                                }
                            }}
                        </Media>
                        <p id={this.state.isSuccess ? "result-dialog-title" : "result-dialog-title-error"}>
                            {this.state.isSuccess ? this.state.title : this.state.errorTitle ? this.state.errorTitle : "Abbiamo riscontrato un problema tecnico."}</p>
                        {this.state.productName !== undefined && <p className={"result-dialog-product-info"}>Nome nuovo Prodotto:</p>}
                        {
                            this.state.productName !== undefined && <p className={"result-dialog-product-info-bold"}>{this.state.productName}</p>
                        }
                        <Route render={({ history }) => {
                            return <p id={"result-dialog-button-go-to-catalog"} className={"result-dialog-button-go-to-catalog"} onClick={() => {
                                window.history.pushState(null, '', '/');
                                history.push('/catalog');
                            }}>{this.state.showComplete ? "Torna al tuo catalogo".toUpperCase() : "Torna al catalogo".toUpperCase()}</p>
                        }}
                        />
                    </div> :
                        <div>
                            <Media query="(max-width: 1064px)">
                                {matches => {
                                    if (matches) {
                                        // Mobile
                                        return <div id={this.state.isSuccess ? "result-dialog-icon" : "result-dialog-icon-error"}>
                                            {
                                                this.state.isSuccess ?
                                                    <ResultOkIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} /> : <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />
                                            }
                                        </div>
                                    } else {
                                        // Desktop
                                        return <div id={"result-dialog-icon"}>
                                            {
                                                this.state.isSuccess ?
                                                    <ResultOkIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} /> : <ResultKoIcon width={"60px"} heigth={"60px"} color={"#2D32AA"} />
                                            }
                                        </div>
                                    }
                                }}
                            </Media>
                            <p id={this.state.isSuccess ? "result-dialog-title" : "result-dialog-title-error"}>
                                {this.state.isSuccess ? this.state.title : this.state.errorTitle ? this.state.errorTitle : "Abbiamo riscontrato un problema tecnico."}</p>
                            <p id={"result-dialog-message"}>{this.state.isSuccess ? this.state.message : this.state.errorMessage ? this.state.errorMessage : ["Riprova più tardi.", <br />, "Grazie per la pazienza."]}</p>
                        </div>
                }

                {
                    [!this.state.isCatalog && <div id={"result-dialog-button-container"}>
                        <Route render={({ history }) => {
                            return <Button id={"result-dialog-submit-button"}
                                type={"button"} onClick={() => {
                                    ResultPageHandler.getInstance().handleButtonCallback(history, this.state.data);
                                }}>{this.state.button}</Button>
                        }} />
                    </div>,
                    this.state.isCatalog && <div id={"result-catalog-dialog-button-container"} style={{ marginTop: this.getMarginForButton() }}>
                        <Route render={({ history }) => {
                            return <Button id={"result-dialog-submit-button"}
                                type={"button"} onClick={() => {
                                    ResultPageHandler.getInstance().handleButtonCallback(history, this.state.data);
                                }}>{this.state.button}</Button>
                        }} />
                    </div>
                    ]
                }
            </div>
        </div>
    }
}